import { JSX } from "react";
import { ProductSpecificationEntry } from "../../utils/dstProductDetailAdapters";
import { ProductDetailColumnGrid } from "../shared/ProductDetailColumnGrid";
import { ProductSpecificationItem } from "./ProductSpecificationItem";

const PRODUCT_SPEC_COLUMN_COUNT = 3;

interface Props {
    entries: ProductSpecificationEntry[];
}

export const ProductSpecificationsGrid = ({ entries }: Props): JSX.Element => {
    const items = entries.map((entry) => (
        <ProductSpecificationItem key={entry.key} entry={entry} />
    ));

    return (
        <ProductDetailColumnGrid
            items={items}
            columnCount={PRODUCT_SPEC_COLUMN_COUNT}
        />
    );
};
